import moment from 'moment'

export const previousContract = (contracts) =>
    [...contracts]
        .sort((a, b) => a.starts_at - b.starts_at)
        .reverse()
        .find(c => c.activated_at && c.ends_at && moment(c.ends_at).isBefore(moment()))

export const activeContract = (contracts) =>
    contracts.find(c => c.activated_at && moment(c.starts_at).isSameOrBefore(moment()) && (!c.ends_at || moment(c.ends_at).isSameOrAfter(moment())))

export const pendingContract = (contracts) =>
    contracts.find(c => c.activated_at && !c.ends_at && moment(c.starts_at).isAfter(moment()))
